// Set to true to enable the Indian tricolour theme site-wide.
// There is no UI control for this — it is a build-time/code-level switch.
export const TRICOLOR_THEME_ENABLED = false;
